import React, { useState } from 'react'
import { 
  AppBar, 
  Box, 
  Toolbar, 
  Typography, 
  Button, 
  Modal, 
  IconButton, 
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField
} from '@mui/material'
import { Close, DeveloperMode, Code } from '@mui/icons-material'
import useEmailEditorStore from '../utilities/emailEditorStore'
import { htmlExport } from '../utilities/htmlExport'
import { validateEmailJSON, loadEmailFromJSON } from '../utilities/JsonGenerator'
import { importHTMLToBlocks, validateHTMLTemplate } from '../utilities/htmlImport'
import PersonalVideoIcon from '@mui/icons-material/PersonalVideo';
import StayCurrentPortraitIcon from '@mui/icons-material/StayCurrentPortrait';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import SaveIcon from '@mui/icons-material/Save';
import PreviewIcon from '@mui/icons-material/Preview';
import DataObjectIcon from '@mui/icons-material/DataObject';
import LayersClearIcon from '@mui/icons-material/LayersClear';

function Topbar() {
  const { blocks, globalProperties, updateGlobalProperties, resetEditor, exportTemplate, loadTemplate } = useEmailEditorStore()
  const [previewOpen, setPreviewOpen] = useState(false)
  const [previewContent, setPreviewContent] = useState('')
  const [resetDialogOpen, setResetDialogOpen] = useState(false)
  const [exportJsonOpen, setExportJsonOpen] = useState(false)
  const [jsonContent, setJsonContent] = useState('')
  const [importJsonOpen, setImportJsonOpen] = useState(false)
  const [importJsonContent, setImportJsonContent] = useState('')
  const [importError, setImportError] = useState('')
  const [importHtmlOpen, setImportHtmlOpen] = useState(false)
  const [importHtmlContent, setImportHtmlContent] = useState('')
  const [importHtmlError, setImportHtmlError] = useState('')

  const handleInputChange = (property, value) => {
    updateGlobalProperties({ [property]: value })
  }

  const handlePreview = () => {
    const htmlContent = htmlExport(blocks, globalProperties)
    console.log(htmlContent)
    setPreviewContent(htmlContent)
    setPreviewOpen(true)
  }

  const handleClosePreview = () => {
    setPreviewOpen(false)
    setPreviewContent('')
  }

  const handleResetClick = () => {
    setResetDialogOpen(true)
  }

  const handleResetConfirm = () => {
    resetEditor()
    setResetDialogOpen(false)
  }

  const handleResetCancel = () => {
    setResetDialogOpen(false)
  }

  const handleExportJson = () => {
    const jsonData = exportTemplate()
    setJsonContent(JSON.stringify(jsonData, null, 2))
    setExportJsonOpen(true)
  }

  const handleCloseExportJson = () => {
    setExportJsonOpen(false)
    setJsonContent('')
  }
 const handleImportJson = () => {
    setImportJsonContent('')
    setImportError('')
    setImportJsonOpen(true)
  }

  const handleCloseImportJson = () => {
    setImportJsonOpen(false)
    setImportJsonContent('')
    setImportError('')
  }

  const handleImportJsonSubmit = () => {
    try {
      const validation = validateEmailJSON(importJsonContent)
      
      if (!validation.isValid) {
        setImportError(validation.errors.join(', '))
        return
      }

      const loadedData = loadEmailFromJSON(importJsonContent)
      
      if (loadedData.blocks && loadedData.blocks.length > 0) {
        resetEditor()
        loadTemplate({
          blocks: loadedData.blocks,
          globalProperties: loadedData.settings
        })
        handleCloseImportJson()
      } else {
        setImportError('No blocks found in the JSON data')
      }
    } catch (error) {
      setImportError(`Failed to import JSON: ${error.message}`)
    }
  }

  const handleImportHtml = () => {
    setImportHtmlContent('')
    setImportHtmlError('')
    setImportHtmlOpen(true)
  }

  const handleCloseImportHtml = () => {
    setImportHtmlOpen(false)
    setImportHtmlContent('')
    setImportHtmlError('')
  }

  const handleImportHtmlSubmit = () => {
    try {
      const validation = validateHTMLTemplate(importHtmlContent)
      
      if (!validation.isValid) {
        setImportHtmlError(validation.errors.join(', '))
        return
      }

      if (validation.warnings.length > 0) {
        console.warn('HTML Import Warnings:', validation.warnings)
      }

      const result = importHTMLToBlocks(importHtmlContent)
      
      if (!result.success) {
        setImportHtmlError(result.message)
        return
      }

      if (result.blocks && result.blocks.length > 0) {
        resetEditor()
        loadTemplate({
          blocks: result.blocks,
          globalProperties: result.globalProperties
        })
        handleCloseImportHtml()
      } else {
        setImportHtmlError('No blocks found in the HTML template')
      }
    } catch (error) {
      setImportHtmlError(`Failed to import HTML: ${error.message}`)
    }
  }
  const handleCopyJson = () => {
    navigator.clipboard.writeText(jsonContent)
      .then(() => {
        // You could add a toast notification here if needed
        console.log('JSON copied to clipboard')
      })
      .catch((err) => {
        console.error('Failed to copy JSON: ', err)
      })
  }

  const downloadHtml = () => {
    const htmlContent = htmlExport(blocks, globalProperties)
    const blob = new Blob([htmlContent], { type: 'text/html' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = globalProperties.templateName || 'email.html'
    link.click()
    URL.revokeObjectURL(url)
  }

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90vw',
    height: '90vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  }

  return (
    <>
      <Box sx={{ flexGrow: 1, mb: 2 }}>
        <AppBar position="static" className="card-border" style={{ borderRadius: 10}} sx={{border:1,boxShadow: 0}} color='transparent' >
          <Toolbar sx={{justifyContent:'space-between'}}>
            <Typography variant="h6" component="div" >
              Email Editor
            </Typography>
            <Box>
              <IconButton color = {globalProperties.viewMode === 'default'?'inherit':'gray'}   onClick={() => handleInputChange('viewMode', 'default')}>
                <PersonalVideoIcon/>
              </IconButton>
              <IconButton color={globalProperties.viewMode === 'mobile'?'inherit':'gray'} onClick={() => handleInputChange('viewMode', 'mobile')}>
                <StayCurrentPortraitIcon/>
              </IconButton>
             
            </Box>
             <Box> 
             <Tooltip title="Import HTML">
                <IconButton color="inherit" onClick={handleImportHtml}>
                  <Code/>
                </IconButton>
                </Tooltip>
             <Tooltip title="Import Json">
                <IconButton color="inherit" onClick={handleImportJson}>
                  <DeveloperMode/>
                </IconButton>
                </Tooltip>
              <Tooltip title="Export Json">
                <IconButton color="inherit" onClick={handleExportJson}>
                  <DataObjectIcon/>
                </IconButton>
                </Tooltip>
              <Tooltip title="Download Html">
                <IconButton color="inherit" onClick={downloadHtml}>
                  <SimCardDownloadIcon/>
                </IconButton>
                </Tooltip>
                <Tooltip title="Preview">
                <IconButton color="inherit" onClick={handlePreview} >
                  <PreviewIcon/>
                </IconButton>
                </Tooltip>
                <Tooltip title="Reset Canvas">
                <IconButton color="inherit" onClick={handleResetClick}>
                  <LayersClearIcon/>
                </IconButton>
                </Tooltip>
               
             </Box>
           
          </Toolbar>
        </AppBar>
      </Box>

      {/* Preview Modal */}
      <Modal
        open={previewOpen}
        onClose={handleClosePreview}
        aria-labelledby="email-preview-modal"
        aria-describedby="email-preview-content"
      >
        <Box sx={modalStyle}>
          {/* Modal Header */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 2,
              borderBottom: 1,
              borderColor: 'divider',
              bgcolor: 'grey.50'
            }}
          >
            <Typography variant="h6" component="h2">
              Email Preview
            </Typography>
            <IconButton onClick={handleClosePreview} size="small">
              <Close />
            </IconButton>
          </Box>

          {/* Modal Content */}
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              bgcolor: 'white'
            }}
          >
            <iframe
              srcDoc={previewContent}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                display: 'block'
              }}
              title="Email Preview"
            />
          </Box>
        </Box>
      </Modal>

      {/* Export JSON Modal */}
      <Modal
        open={exportJsonOpen}
        onClose={handleCloseExportJson}
        aria-labelledby="export-json-modal"
        aria-describedby="export-json-content"
      >
        <Box sx={modalStyle}>
          {/* Modal Header */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 2,
              borderBottom: 1,
              borderColor: 'divider',
              bgcolor: 'grey.50'
            }}
          >
            <Typography variant="h6" component="h2">
              Export JSON
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="outlined"
                size="small"
                onClick={handleCopyJson}
              >
                Copy to Clipboard
              </Button>
              <IconButton onClick={handleCloseExportJson} size="small">
                <Close />
              </IconButton>
            </Box>
          </Box>

          {/* Modal Content */}
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              p: 2
            }}
          >
            <TextField
              multiline
              fullWidth
              value={jsonContent}
              variant="outlined"
              InputProps={{
                readOnly: true,
                sx: {
                  fontFamily: 'monospace',
                  fontSize: '0.78rem',
                  '& .MuiInputBase-input': {
                    whiteSpace: 'pre-wrap'
                  }
                }
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  height: '100%',
                  alignItems: 'flex-start'
                }
              }}
            />
          </Box>
        </Box>
      </Modal>

      {/* Import HTML Modal */}
      <Modal
        open={importHtmlOpen}
        onClose={handleCloseImportHtml}
        aria-labelledby="import-html-modal"
        aria-describedby="import-html-content"
      >
        <Box sx={modalStyle}>
          {/* Modal Header */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 2,
              borderBottom: 1,
              borderColor: 'divider',
              bgcolor: 'grey.50'
            }}
          >
            <Typography variant="h6" component="h2">
              Import HTML
            </Typography>
            <IconButton onClick={handleCloseImportHtml} size="small">
              <Close />
            </IconButton>
          </Box>

          {/* Modal Content */}
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              gap: 2
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Paste your HTML email template below. The HTML will be parsed and converted to editable blocks.
            </Typography>
            
            <TextField
              multiline
              fullWidth
              rows={20}
              value={importHtmlContent}
              onChange={(e) => setImportHtmlContent(e.target.value)}
              placeholder='Paste your HTML here...'
              variant="outlined"
              error={!!importHtmlError}
              helperText={importHtmlError}
              InputProps={{
                sx: {
                  fontFamily: 'monospace',
                  fontSize: '0.78rem',
                  '& .MuiInputBase-input': {
                    whiteSpace: 'pre-wrap'
                  }
                }
              }}
            />

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
              <Button
                variant="outlined"
                onClick={handleCloseImportHtml}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleImportHtmlSubmit}
                disabled={!importHtmlContent.trim()}
              >
                Import
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Import JSON Modal */}
      <Modal
        open={importJsonOpen}
        onClose={handleCloseImportJson}
        aria-labelledby="import-json-modal"
        aria-describedby="import-json-content"
      >
        <Box sx={modalStyle}>
          {/* Modal Header */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 2,
              borderBottom: 1,
              borderColor: 'divider',
              bgcolor: 'grey.50'
            }}
          >
            <Typography variant="h6" component="h2">
              Import JSON
            </Typography>
            <IconButton onClick={handleCloseImportJson} size="small">
              <Close />
            </IconButton>
          </Box>

          {/* Modal Content */}
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              gap: 2
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Paste your email template JSON below. The JSON will be validated before importing.
            </Typography>
            
            <TextField
              multiline
              fullWidth
              rows={20}
              value={importJsonContent}
              onChange={(e) => setImportJsonContent(e.target.value)}
              placeholder='Paste your JSON here...'
              variant="outlined"
              error={!!importError}
              helperText={importError}
              InputProps={{
                sx: {
                  fontFamily: 'monospace',
                  fontSize: '0.78rem',
                  '& .MuiInputBase-input': {
                    whiteSpace: 'pre-wrap'
                  }
                }
              }}
            />

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
              <Button
                variant="outlined"
                onClick={handleCloseImportJson}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleImportJsonSubmit}
                disabled={!importJsonContent.trim()}
              >
                Import
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Reset Confirmation Dialog */}
      <Dialog
        open={resetDialogOpen}
        onClose={handleResetCancel}
        aria-labelledby="reset-dialog-title"
        aria-describedby="reset-dialog-description"
      >
        <DialogTitle id="reset-dialog-title">
          Reset Canvas
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="reset-dialog-description">
            Do you want to clear all the blocks and reset the email? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResetCancel} color="primary">
            No
          </Button>
          <Button onClick={handleResetConfirm} color="primary" variant="contained">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Topbar